'use client';
import styled, { css } from 'styled-components';

export const ProductSelectionContainer = styled.div`
  min-width: 0;
  width: fit-content;
  max-width: 100vw;
  overflow-x: scroll;
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing(props.$mobileGapSize)};
  margin: auto;
  &::-webkit-scrollbar {
    display: none;
  }

  ${props =>
    !props.$stackOnMobile &&
    css`
      display: grid;
      grid-template-columns: repeat(${props => props.$mobileGridColumns}, 1fr);
    `};

  @media ${props => props.theme.laptop} {
    display: grid;
    grid-template-columns: repeat(${props => props.$gridColumns}, 1fr);
    gap: ${props => props.theme.spacing(props.$gapSize)};
    padding: 0;
  }
`;

export const ProductCardWrapper = styled.div`
  display: flex;
  justify-content: center;
  min-width: min-content;
  max-width: 33%;
`;
